import {
  Environment,
  mapTilerKey,
  prodAgoraAppId,
  prodApiUrl,
  prodFirebaseConfig,
  prodFirebaseTokenId,
  prodFirebaseVapidKey,
  prodWsDomain,
  prodSupersetDomain,
  prodSupersetDashboardIds,
  prodFacebookConfigId,
} from ".";

export const environment: Environment = {
  env: "prod",
  production: true,
  firebaseConfig: prodFirebaseConfig,
  firebaseVapidKey: prodFirebaseVapidKey,
  sentryDsn:
    "https://12fd260d42b8eef1b61f92ec6fbf31cb@o1211156.ingest.us.sentry.io/4506969804767232",
  sentryWhitelistHosts: [
    "web.jugl.com",
    /jugl-prod-org-web-rc-\d+-\d+-\d+.netlify.app/g,
  ],
  posthogApiKey: "phc_xBX75uEtVnHb7dDrf9gryebawZaC8NV7RqpL8bC4hAhg",
  posthogHost: "https://us.i.posthog.com",
  posthogWhitelistHosts: [
    "web.jugl.com",
    "beta.jugl.com",
    /jugl-prod-org-web-rc-\d+-\d+-\d+.netlify.app/g,
  ],
  apiUrl: prodApiUrl,
  wsDomain: prodWsDomain,
  firebaseTokenId: prodFirebaseTokenId,
  mapTilerKey,
  geocodingKey: atob("QUl6YVN5RFFBMGRkUEl1MGEwcG83U3J5eVRRS3NGMWFaQ1lpMHk4"),
  agoraAppId: prodAgoraAppId,
  chatBotToken:
    "mj2C35LOCzsygvpvdAdKsu7LbXsxLAFT56p6BpOMQ6iuZcfipJd8/2zHKQ2vyAmvhMNc0aCpm612d5KWZMd5NA==",
  supersetDomain: prodSupersetDomain,
  supersetDashboardIds: prodSupersetDashboardIds,
  supersetChartIdToType: { 114: "tasks", 117: "people", 122: "travelLog" },
  isReCaptchaEnabled: true,
  reCaptchaKey: "6LdMnvopAAAAAID5SLUbjhOfVLc2BDzMlvJPr3nn",
  guestUrl: "https://guest.jugl.com",
  facebookConfigId: prodFacebookConfigId,
  featureFlags: {
    maxChatAttachmentsCount: 10,
  },
  demoToken: "",
  instagramClientId: "31471236829189745",
  chatBotUrl: "https://chat-bot.jugl.com",
  liveChatUrl: "https://live-chat.jugl.com",
  escapeChatChars: false,
};
